import React, { useCallback, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import MultiLevelSelect from '../../../../components/MultiLevelSelect'

import { clearTikTokRegions, getTikTokRegions } from '../../../../modules/actions/tikTokConstants'
import { selectedTikTokAdAccountSelector } from '../../../../modules/selectors/adAccounts'
import { campaignSelector } from '../../../../modules/selectors/campaigns'
import { tikTokRegionsIsLoadingSelector, tikTokRegionsSelector } from '../../../../modules/selectors/tikTokConstants'
import { tiktokRightUploadAdDataSelector } from '../../../../modules/selectors/rights'

const TiktokGeolocationRegion = ({ name, value, setFieldValue }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const campaign = useSelector(campaignSelector)
  const { campaign: rightUploadCampaign } = useSelector(tiktokRightUploadAdDataSelector)
  const { objective: rightUploadCampaignObjective } = rightUploadCampaign
  const tikTokRegions = useSelector(tikTokRegionsSelector)

  const tikTokRegionsIsLoading = useSelector(tikTokRegionsIsLoadingSelector)

  const { objective: campaignObjective } = campaign

  const formattedRegionOptions = useMemo(
    () =>
      tikTokRegions.map(region => ({
        ...region,
        parent: region['parent_id']
      })),
    [tikTokRegions]
  )

  const flatToNestedRegionsSortFunction = useCallback((a, b) => a.name.localeCompare(b.name), [])

  useEffect(() => {
    dispatch(
      getTikTokRegions({
        objective_type: campaignObjective || rightUploadCampaignObjective,
        account: selectedAdAccountId,
        placement: ['PLACEMENT_TIKTOK']
      })
    )
  }, [dispatch, campaignObjective, rightUploadCampaignObjective, selectedAdAccountId])

  useEffect(
    () => () => {
      dispatch(clearTikTokRegions())
    },
    [dispatch]
  )

  return (
    <MultiLevelSelect
      placeholder={t('Add a region')}
      setFieldValue={setFieldValue}
      value={value}
      name={name}
      options={formattedRegionOptions}
      isLoading={tikTokRegionsIsLoading}
      flatToNestedArrSortFunction={flatToNestedRegionsSortFunction}
    />
  )
}

TiktokGeolocationRegion.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.array,
  setFieldValue: PropTypes.func.isRequired
}

export default TiktokGeolocationRegion
